import * as React from 'react'

import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { translate } from 'utils/intl/helper'
import { KEYS } from 'utils/intl/constant'
import { selectList, addModelFiltred, setSearchActive } from '../../../store/reducer/model'
import { useAppSelector, useAppDispatch } from '../../../store/hooks'
import SearchBar from '../../component/shared/search/SearchBar'

const Container = styled.div`
    position: relative;
    width: 300px;
    margin: 0 24px;
`

const Search = () => {
    const modelList = useAppSelector((state) => selectList(state.model))
    const intl = useAppSelector((state) => state.ui.intl)

    const dispatch = useAppDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const [selected, setSelected] = useState('')
    const [hasStartedTyping, setHasStartedTyping] = useState(false)

    useEffect(() => {
        dispatch(
            dispatch(
                addModelFiltred(
                    selected && selected !== ''
                        ? modelList.filter((item: any) =>
                              (item.info?.modelName || item.model || '').toLocaleLowerCase().includes(selected.toLocaleLowerCase())
                          )
                        : modelList
                )
            )
        )
    }, [selected, modelList])

    const onInputChange = (_: React.SyntheticEvent, value: string) => {
        setSelected(value)
        if (value.length === 1 && !hasStartedTyping) {
            if (location.pathname.startsWith('/model/')) {
                navigate('/')
            }
            dispatch(setSearchActive(true))
            setHasStartedTyping(true)
        } else if (value.length === 0 && hasStartedTyping) {
            dispatch(setSearchActive(false))
            setHasStartedTyping(false)
        }
    }

    const options = modelList.map(({ model }) => ({
        label: model,
        value: model,
    }))

    return (
        <Container>
            <SearchBar
                label={translate(intl, KEYS.UI_SEARCH)}
                options={options}
                onInputChangeCallback={onInputChange}
            />
        </Container>
    )
}

export default Search
